import PropTypes from 'prop-types';
import { Flex } from '@components/grid';
import { P } from '@components/typography/new';
import { HeadingWithFlameHighlights } from '@components/heading-with-flame-highlights';

const QuestionHeader = ({ title, description, required }) => {
  return (
    <Flex gap="12px" flexDirection="column" width="100%">
      <Flex justifyContent="space-between" alignItems="center">
        <HeadingWithFlameHighlights heading={title} mb="0" variant="section" />
        {required && (
          <P variant="small" color="grey70">
            Required
          </P>
        )}
      </Flex>

      <P>{description}</P>
    </Flex>
  );
};

QuestionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
};

export { QuestionHeader };
